import React from 'react';
import { RatingIcon } from './img/rating_icon.js';
import Icon from '../icon/icon.js';
import Title from '../title/title.js';
import modules_a2428c96 from './rating.module.scss.js';
import classNames from '../../classnames.js';

const Rating = ({ type, rating, withBorder = false, loading }) => {
    const getFontStyle = () => {
        if (type === "medium")
            return "content-medium";
        if (type === "small")
            return "content-small";
        return "content-default";
    };
    const getRatingContainerClassname = () => classNames(modules_a2428c96[`rating-${type}-container`], {
        [modules_a2428c96["rating-border-container"]]: withBorder
    });
    const renderRating = () => (React.createElement("div", { className: getRatingContainerClassname(), "data-testid": "mbw-rating-container" },
        React.createElement(Icon, { className: modules_a2428c96[`rating-${type}-icon`], loading: loading }, RatingIcon),
        React.createElement(Title, { fontStyle: getFontStyle(), bold: true, loading: loading }, rating)));
    return renderRating();
};

export { Rating as default };
//# sourceMappingURL=rating.js.map
